module.exports = __webpack_public_path__ + "img/member-login.1922e136.svg";